import { useEffect, useRef, useState } from "react";
import { StyledDropdown } from "../../Components/Dropdown";
import { NavLink } from "react-router-dom";
import { ProfileDefaultButton } from "../../Components/IconButtons";
import { useStores } from "../..";
import { AppStoreApi } from "../../Stores/AppStore";
import { CheckArgs } from "../../utils/checks/CheckArgsWithoutThrow";

export let ProfileDropdown: React.FC<{}> = () => {
  let [isMenuOpen, setIsMenuOpen] = useState(false);

  const dropdownRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const checkIfClickedOutside = (e: MouseEvent) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (
        isMenuOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as HTMLElement)
      )
        setIsMenuOpen(false);
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isMenuOpen]);

  let appStores: AppStoreApi = useStores();

  if (CheckArgs.CheckNullOrUndefinedOrEmptyString(appStores.userStore.user)) {
    appStores.authStore.logout();
    return <></>;
  }

  return (
    <StyledDropdown
      ref={dropdownRef}
      $is_menu_active={isMenuOpen}
      className="profile-dropdown"
    >
      <ProfileDefaultButton onClick={() => setIsMenuOpen(!isMenuOpen)} />

      {isMenuOpen && (
        <menu>
          <li>{appStores.userStore.user!.userName}</li>
          <hr />
          <li>
            <NavLink to={"/profile"}>Профиль</NavLink>
          </li>
          <li>
            <NavLink to="/" onClick={() => appStores.authStore.logout()}>
              Выход
            </NavLink>
          </li>
        </menu>
      )}
    </StyledDropdown>
  );
};
